import { createSelector } from '@reduxjs/toolkit';

import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getAnalogModelForActiveComponentDesign = createSelector(
  getActiveComponentDesign,
  (activeComponentDesign) => (activeComponentDesign ? activeComponentDesign.analogModel : null),
);
